import { AfterViewInit, Directive, ElementRef, HostBinding } from '@angular/core';
import { injectElementRef } from '@qpoint/utils';

@Directive({
  selector: '[qpointModalResizable]',
  standalone: true
})
export class ModalResizableDirective implements AfterViewInit {
  private elementRef: ElementRef<HTMLElement> = injectElementRef()

  @HostBinding('class.qpoint-modal-resizable') qpointModalResizable = true;

  ngAfterViewInit() {
    // set initial width to bootstrap variable default
    this.elementRef.nativeElement.style.width = getComputedStyle(this.elementRef.nativeElement).getPropertyValue('--bs-modal-width');
    this.elementRef.nativeElement.style.minHeight = this.elementRef.nativeElement.clientHeight + 'px';
  }
}
